var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUchida(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1370.1 600",
    style: {
      enableBackground: "new 0 0 1370.1 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#221815;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1370.1,
    height: 600
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.9,335.4V230.9h-42.5v113.4h-85.1V230.9h-42.5v104.6c0,37.5,47.5,37.5,47.5,37.5h75.9 C315.9,372.9,315.9,335.4,315.9,335.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.8,283.2c0,0,0.6-52,42.5-52h89.8c0,0,42.2,1.8,42.2,43.7v8h-47.3v-23.1h-80.3v84.5h80.3v-23h47.3v7.9 c0,42-42.2,43.7-42.2,43.7h-89.8c-41.9,0-42.5-52-42.5-52V283.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 750.6,
    y: 235.9,
    className: "st1",
    width: 47.2,
    height: 137
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "675.3,235.9 675.3,292.6 580.8,292.6 580.8,235.9 533.6,235.9 533.6,372.9 580.8,372.9 580.8,321  675.3,321 675.3,372.9 722.6,372.9 722.6,235.9 675.3,235.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M968.5,235.6H826.2v137.3h147.1c0,0,42.2,0,42.2-51.6v-42.6C1015.5,278.7,1015.5,235.6,968.5,235.6  M967.9,344.3H874v-79.7h93.9V344.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1181.1,372.9h50.2l-83.2-127.2c0,0-25.7-32.8-53.2,0l-83.3,127.2h50.2l13.5-23.9h92.2L1181.1,372.9  M1091.4,320.7l30-53.1l30.1,53.1H1091.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUchida);
export default __webpack_public_path__ + "static/media/uchida.959a4579.svg";
export { ForwardRef as ReactComponent };